import { render } from "./OfflineBanner.vue?vue&type=template&id=3afd7270&scoped=true"
import script from "./OfflineBanner.vue?vue&type=script&lang=js"
export * from "./OfflineBanner.vue?vue&type=script&lang=js"

import "./OfflineBanner.vue?vue&type=style&index=0&id=3afd7270&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3afd7270"]])

export default __exports__